// Add a comment to indicate this component's new position at the top of the dashboard
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { ArrowUpIcon } from 'lucide-react';

export function InsightsSummary() {
  return (
    // This card is positioned near the top of the dashboard for quick visibility
    <Card className='h-[320px] shadow-none'>
      <CardHeader>
        <CardTitle>Insights Summary</CardTitle>
        <CardDescription className='text-md'>
          Weekly performance digest
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className='text-lg'>
          This week you gained <span className='font-bold'>142</span> new
          loyalty members and made <span className='font-bold'>$3,220</span>{' '}
          from loyalty. Email open rates are up{' '}
          <span className='font-bold text-emerald-600 inline-flex items-center'>
            12% <ArrowUpIcon className='h-4 w-4 ml-1' />
          </span>
          .
        </p>
      </CardContent>
    </Card>
  );
}
